<div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">{{ 'customerdeal.title' | trans }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span >&times;</span>
        </button>
      </div>
      <div class="modal-body">
          <div class="row">
              <div class="col">
                  <p class="mb-0 f-13 text-muted font-weight-bold">{{ 'customerdeal.name' | trans }}</p>
                  <p>{{ modalDeal.dealname }}</p>
              </div>
              <div class="col">
                  <p class="mb-0 f-13 text-muted font-weight-bold">{{ 'customerdeal.owner' | trans }}</p>
                  <p>{{ modalDeal.dealowner}}</p>
              </div>
              <div class="col">
                  <p class="mb-0 f-13 text-muted font-weight-bold">{{ 'customerdeal.dealdate' | trans }}</p>
                  <p>{{ modalDeal.dealdate | date: 'yyy-MM-dd' }}</p>
              </div>
              <div class="col">
                  <p class="mb-0 f-13 text-muted font-weight-bold">{{ 'customerdeal.status' | trans }}</p>
                  <p>{{ modalDeal.dealstatus }}</p>
              </div>
          </div> 

                <div class="row mt-2b">
              <div class="col">
                  <p class="text-muted f-13 mb-0 font-weight-bold">{{ 'customerdeal.relatedprojects' | trans }}</p>
              </div>
              <div class="col">
                  <p class="mb-0 f-13 text-muted font-weight-bold">{{ 'customerdeal.startdate' | trans }}</p>
              </div>
              <div class="col">
                  <p class="mb-0 f-13 text-muted font-weight-bold">{{ 'customerdeal.duedate' | trans }}</p>
              </div>
              <div class="col">
                  <p class="mb-0 f-13 text-muted font-weight-bold">{{ 'customerdeal.status' | trans }}</p>
              </div>
            </div>
            <div class="card pl-2 mb-2" *ngFor="let  proj of dealProjects">
              <div class="row">
                <div class="col">
                    <a class="cursor-pointer"><p class="mb-0 align-middle lh-50"><b>{{ proj.title }}</b></p></a>
                </div>
                <div class="col">
                    <a class="cursor-pointer"><p class="mb-0 align-middle lh-50">{{ proj.start_date | date:'yyyy-MM-dd'}}</p></a>
                </div>
                <div class="col">
                    <a class="cursor-pointer"><p class="mb-0 align-middle lh-50">{{ proj.end_date | date:'yyyy-MM-dd' }}</p></a>
                </div>
                <div class="col">
                    <ng-container  *ngIf="proj.overduedays == 0 && proj.progress == 0">
                        <div style="margin-top:4px; margin-right: 3px;">
                          <circle-progress
                          [percent]="proj.progress"
                          [radius]="18"
                          [outerStrokeWidth]="0"
                          [titleFontSize]="12"
                          [titleFontWeight]="700"
                          [subtitleFontSize]="0"
                          [outerStrokeColor]="'#ccc'"
                          [titleColor]="'#ccc'"
                          [animation]="true"
                          [animationDuration]="100"
                          [unitsFontSize]="12"
                          [unitsFontWeight]="700"
                          [unitsColor]="'#ccc'"
                        ></circle-progress>
                        </div>
                      </ng-container>
                        <circle-progress *ngIf="proj.overduedays == 0 && proj.progress < 100 && proj.progress != 0 "
                        [percent]="proj.progress"
                        [radius]="18"
                        [outerStrokeWidth]="3"
                        [titleFontSize]="12"
                        [subtitleFontSize]="0"
                        [outerStrokeColor]="'#43aa8b'"
                        [titleColor]="'#43aa8b'"
                        [animation]="true"
                        [animationDuration]="100"
                        [unitsFontSize]="12"
                        [unitsColor]="'#43aa8b'"
                      ></circle-progress>
                      <ng-container *ngIf="proj.overduedays == 0 && proj.progress == 100">
                        <div style="margin-top:8px; margin-right:5px;">
                          <circle-progress 
                          [percent]="proj.progress"
                          [radius]="18"
                          [titleFontSize]="12"
                          [subtitleFontSize]="0"
                          [titleFontWeight]="700"
                          [titleColor]="'#43aa8b'"
                          [outerStrokeWidth]="0"
                          [animation]="true"
                          [animationDuration]="100"
                          [unitsFontSize]="12"
                          [unitsColor]="'#43aa8b'"
                          [unitsFontWeight]="700"
                          [backgroundPadding]="1"
                        ></circle-progress>
                        </div>
                      </ng-container>
                      <circle-progress *ngIf="proj.overduedays > 0 && proj.overduedays <= 3"
                        [percent]="proj.progress"
                        [radius]="18"
                        [outerStrokeWidth]="3"
                        [titleFontSize]="12"
                        [subtitleFontSize]="0"
                        [outerStrokeColor]="'yellow'"
                        [titleColor]="'yellow'"
                        [animation]="true"
                        [animationDuration]="100"
                        [unitsFontSize]="12"
                        [unitsColor]="'yellow'"
                      ></circle-progress>
                      <circle-progress *ngIf="proj.overduedays > 3 && proj.progress > 0"
                        [percent]="proj.progress"
                        [radius]="18"
                        [outerStrokeWidth]="3"
                        [titleFontSize]="12"
                        [subtitleFontSize]="0"
                        [outerStrokeColor]="'#ef3054'"
                        [titleColor]="'#ef3054'"
                        [animation]="true"
                        [animationDuration]="100"
                        [unitsFontSize]="12"
                        [unitsColor]="'#ef3054'"
                      ></circle-progress>
                      <ng-container *ngIf="proj.overduedays > 3 && proj.progress == 0">
                        <div  style="margin-top:6px; margin-right:5px;">
                          <circle-progress  
                          [percent]="proj.progress"
                          [radius]="16"
                          [outerStrokeWidth]="3"
                          [titleFontSize]="15"
                          [subtitleFontSize]="0"
                          [outerStrokeColor]="'#ef3054'"
                          [titleColor]="'white'"
                          [animation]="true"
                          [animationDuration]="100"
                          [unitsFontSize]="15"
                          [unitsColor]="'white'"
                          [backgroundColor]="'#ef3054'"
                          [backgroundPadding]="1"
                        ></circle-progress>
                        </div>
                      </ng-container>
                </div>
              </div>
            </div>

            <div class="card mt-3">
              <div class="card-body">
                  <quill-view-html  [content]="modalDeal.dealdetail"></quill-view-html>
                </div>
            </div>
      </div>
    </div>
  </div>